// src/features/mocktests/components/TestResultsPopup.js
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTestNavigation } from "../../../utils/testNavigation";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from "@mui/material";
import { CheckCircle as CheckCircleIcon } from "@mui/icons-material";

const gradeColors = {
  A: "#4caf50", // Green
  B: "#8bc34a", // Light Green
  C: "#2196f3", // Blue
  D: "#ff9800", // Orange
  E: "#f44336", // Red
};

const TestResultsPopup = ({ open, onClose, resultsData, onContinue, attemptId, mockTestId }) => {
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState(0);
  const [expandedQuestion, setExpandedQuestion] = useState(false);

  // Effect to pause timers and audio when popup opens
  useEffect(() => {
    if (open) {
      // Pause all audio elements
      const audioElements = document.querySelectorAll("audio");
      audioElements.forEach((audio) => {
        if (!audio.paused) {
          audio.pause();
        }
      });

      // Stop/pause timers by dispatching a custom event
      window.dispatchEvent(new CustomEvent("pauseTestTimers"));
    }
  }, [open]);

  const handleContinue = () => {
    // Call the onContinue callback if provided
    if (onContinue) {
      onContinue();
    } else {
      // Navigate to back route (will be determined by test type)
      navigate(backRoute);
    }

    // Close the popup
    onClose();
  };

  const { getAttemptResultUrl, backRoute } = useTestNavigation();

  // Simplified submission modal: show a compact confirmation and allow user to view full results
  const handleViewResult = () => {
    // Prefer explicit mockTestId and attemptId props; fall back to values in resultsData if available
    const attempt = attemptId || resultsData?.data?.studentAttemptId || resultsData?.data?._id;
    const mockId = mockTestId || resultsData?.data?.mockTestId || resultsData?.data?.testId;
    if (attempt && mockId) {
      navigate(getAttemptResultUrl(mockId, attempt));
    } else {
      // If we don't have ids, just close and fallback to continue behavior
      if (onContinue) onContinue();
      if (onClose) onClose();
    }
  };
  

  return (
   <Dialog
  open={open}
  maxWidth="sm"
  fullWidth
  disableEscapeKeyDown
  PaperProps={{
    sx: {
      // compact modal
      maxWidth: 520,
    },
  }}
  onClose={(event, reason) => {
    // Prevent closing on backdrop click or escape
    if (reason === "backdropClick" || reason === "escapeKeyDown") return;
    if (onClose) onClose();
  }}
>
      <DialogTitle sx={{ bgcolor: '#9D2235', color: 'white', py: 1, px: 2 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>Test Submitted</Typography>
      </DialogTitle>

      <DialogContent sx={{ p: 2, textAlign: 'center' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1, py: 1 }}>
          <CheckCircleIcon sx={{ fontSize: 40, color: '#9D2235' }} />
          <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>Test Submitted</Typography>
          <Typography variant="body2" sx={{ color: '#666', maxWidth: 420 }}>Your submission has been received. You can view the detailed result for this attempt.</Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 1, pt: 0, justifyContent: 'flex-end', gap: 1 }}>
        <Button onClick={handleContinue} variant="text" size="small">Back To Tests</Button>
        <Button onClick={handleViewResult} variant="contained" size="small" sx={{ bgcolor: '#9D2235', '&:hover': { bgcolor: '#7a182a' }, px: 2 }}>View Result</Button>
      </DialogActions>
    </Dialog>
  );
};

export default TestResultsPopup;
